import { render, staticRenderFns } from "./ExportConfig.vue?vue&type=template&id=37870954&"
import script from "./ExportConfig.vue?vue&type=script&lang=js&"
export * from "./ExportConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports